module.exports = __webpack_public_path__ + "media/images/blankProfile-8f6d005f.png";